<template>
  <v-form ref="form">
    <div>
      <v-breadcrumbs class="px-0" :items="items"></v-breadcrumbs>
      <!--    <loading :active.sync="isLoading" :is-full-page="true"></loading>-->
      <!-- This page fetches its own item, and the store keeps the last one opened
           (persisted), so it can still be empty or stale when the page is revealed.
           Until the item for this URL is in, hold a full viewport and keep the block
           hidden: the footer stays off-screen, and the title's line count - known
           only once it arrives - can't push the rest down on screen. -->
      <div :style="{ 'min-height': ebookReady ? null : '100vh', 'visibility': ebookReady ? null : 'hidden' }">
        <v-row>
          <v-col>
            <span class="text-tcdc-green bold header text-uppercase">{{ $t('ebook.ebook') }}</span>
          </v-col>
        </v-row>
        <v-row class="mb-4">
          <v-col cols="12" sm="6" md="6" :class="{'pr-4': $vuetify.breakpoint.smAndUp}">
            <EbookImageCard :image="ebook.cover_img_path !='' ? ebook.cover_img_path: book_defalut " @onClick="dialog = true; set_url(ebook[`file_path_desktop_${lang}`])"/>
          </v-col>
          <v-col
              cols="12"
              sm="6"
              md="6"
              :class="{'pl-4': $vuetify.breakpoint.smAndUp}"
              class="d-flex flex-1 flex-column"
          >
            <p class="font_h text-tcdc-green header bold">{{ ebook[`subject_${lang}`] }}</p>
            <p
                class="vhtml bold"
                v-html="ebook[`intro_${lang}`]"
            ></p>
            <!-- <div class="d-flex"> -->
            <div class="mb-4">
              <span class="mr-4 text-tcdc-grey1 bold">{{ ebook[`article_date_${lang}`] }}</span>
              <img src="../../assets/icons/generals/download.png" class="tcdc-download-icon mr-2"/>
              <span class="text-tcdc-grey1 bold">{{ formatNumber(ebook.count_download) }}</span>
            </div>
            <!-- </div> -->
            <v-row>
              <v-col cols="12" md="8" class="d-flex flex-column">
                <v-dialog v-if="ebook[`show_dialog`]==1" v-model="dialog" max-width="560">
                  <template v-slot:activator="{ on }">
                    <!-- <v-btn style="margin-bottom: 16px!important;height: 30px; min-width: 120px; width: 250px;" v-if="ebook[`file_path_desktop_${lang}`]" dark v-bind="attrs" v-on="on"
                                @click="set_url(ebook[`file_path_desktop_${lang}`])"
                                width="250px" min-width="120" rounded :height="height" class="active-color">
                      <span class="bold text-uppercase px-5" style="color: #fff;">
                        desktop version
                      </span>
                    </v-btn>
                    <v-btn style=" margin-bottom: 16px!important;height: 30px; min-width: 120px; width: 250px;"
                          v-if="ebook[`file_path_mobile_${lang}`]" dark v-bind="attrs" v-on="on"
                                @click="set_url(ebook[`file_path_mobile_${lang}`])"
                                width="250px" min-width="120"
                                rounded :height="height"
                                class="active-color mb-6">
                      <span class="bold text-uppercase px-5" style="color: #fff;">
                        mobile/tablet version
                      </span>
                    </v-btn> -->
                    <div v-on="on">
                      <GreenButtonDowload v-if="ebook[`file_path_desktop_${lang}`]"
                                          dark
                                          width="250px"
                                          label="desktop version"
                                          class="mb-4"
                                          @onPress="set_url(ebook[`file_path_desktop_${lang}`])"
                      />
                      <GreenButtonDowload v-if="ebook[`file_path_mobile_${lang}`]"
                                          dark
                                          width="250px"
                                          label="mobile/tablet version"
                                          class="mb-6"
                                          @onPress="set_url(ebook[`file_path_mobile_${lang}`])"
                      />
                    </div>
                  </template>
                  <v-card class="pa-10">
                    <a type="button" style="color: #aaaaaa;float: right;font-weight: bold;" @click="dialog=false">x</a>
                    <div class="text-tcdc-green bold header font-head mb-6">{{ $t('ebook.InputAllFrom') }}</div>
                    <v-row>
                      <v-col cols="12">
                        <v-text-field outlined dense hide-details border- color="#2e8037"
                                      class="font ebook-info-download" ref="name" v-model="name"
                                      :label="$t('ebook.name')" required></v-text-field>
                      </v-col>
                      <v-col cols="12">
                        <v-text-field :rules="emailRules" type="email"
                                      outlined dense hide-details color="#2e8037"
                                      class="font ebook-info-download" ref="email"
                                      v-model="email" :label="$t('ebook.email')" required>
                        </v-text-field>
                      </v-col>
                      <v-col cols="12">
                        <v-text-field outlined dense hide-details color="#2e8037" class="font ebook-info-download"
                                      ref="occupation" v-model="occupation" :label="$t('ebook.occupation')"
                                      required></v-text-field>
                      </v-col>
                      <v-col cols="12">
                        <v-select outlined
                                  dense
                                  hide-details
                                  menu-props="offsetY"
                                  color="#2e8037"
                                  ref="industry_id"
                                  v-model="industry_id"
                                  class="font ebook-info-download"
                                  :items="creatives"
                                  :label="$t('ebook.industry')"
                                  :item-text="'name_'+$i18n.locale"
                                  item-value="id"
                                  required
                                  style="min-height:56px;">
                        </v-select>
                      </v-col>
                      <v-col v-if="industry_id==16" cols="12">
                        <v-textarea outlined dense hide-details
                                    color="#2e8037"
                                    v-model="industry_other" class="font"
                                    required>
                        </v-textarea>
                      </v-col>
                    </v-row>
                    <div class="d-flex align-center mt-3 mb-10" style="gap: 8px">
                      <v-checkbox
                          ref="accept"
                          dense
                          hide-details
                          color="#2e8037"
                          v-model="accept"
                          class="font font_10 checkbox-eb"
                      ></v-checkbox>
                      <div class="pt-2">
                        {{ $t('ebook.accept') }}
                        <a v-if="$i18n.locale === 'en'" href="https://www.cea.or.th/en/privacy-policy" target="_blank"
                           style="color: #2e8037 !important;">Privacy Policy.</a>
                        <a v-else href="https://www.cea.or.th/th/privacy-policy" target="_blank"
                           style="color: #2e8037 !important;">นโยบายการคุ้มครองข้อมูลส่วนบุคคล</a>
                      </div>
                    </div>
                    <v-spacer></v-spacer>
                    <v-layout justify-space-between>
                      <v-flex shrink style="min-width:200px; max-width:200px;">
                        <v-btn width="100%" style="border-color:#2e8037;" rounded outlined color="#2e8037" text
                               @click="cancel()">
                          <div class="black--text font">{{ $t('ebook.cancel') }}</div>
                        </v-btn>
                      </v-flex>
                      <v-flex shrink style="min-width:200px; max-width:200px; ">
                        <v-btn width="100%" :disabled="!accept" rounded color="#2e8037" @click="send_info()">
                          <div class="white--text font">
                            {{ $t('ebook.download') }}
                          </div>
                        </v-btn>
                      </v-flex>
                    </v-layout>
                  </v-card>
                </v-dialog>

                <GreenButton
                    v-if="ebook[`file_path_desktop_${lang}`] && ebook[`show_dialog`]==0"
                    width="250px"
                    label="desktop version"
                    class="mb-4"
                    @onPress="downloadEbook(ebook[`file_path_desktop_${lang}`])"
                />
                <GreenButton
                    v-if="ebook[`file_path_mobile_${lang}`] && ebook[`show_dialog`]==0"
                    width="250px"
                    label="mobile/tablet version"
                    class="mb-6"
                    @onPress="downloadEbook(ebook[`file_path_mobile_${lang}`])"
                />
                <ShareButton mode="e-book" :title="ebook[`subject_${lang}`]"
                             :description="ebook[`intro_${lang}`]"></ShareButton>
              </v-col>
            </v-row>
          </v-col>
        </v-row>
        <v-row class="mb-12">
          <v-col>
        <span class="vhtml" v-html="ebook[`detail_${lang}`]">
        </span>
          </v-col>
        </v-row>
        <!--    <v-row>-->
        <!--      <v-col class="pb-0">-->
        <!--        <span class="text-tcdc-green bold sub-header1 text-uppercase">related e-book</span>-->
        <!--      </v-col>-->
        <!--    </v-row>-->
        <!--    <v-row>-->
        <!--      <template v-for="item of 3">-->
        <!--        <v-col cols="12" sm="6" md="4" :key="item.toString()">-->
        <!--          <EbookCard :border="false" />-->
        <!--        </v-col>-->
        <!--      </template>-->
        <!--    </v-row>-->
      </div>
    </div>
  </v-form>
</template>

<script>
import EbookImageCard from "../../components/cards/EbookImageCard";
import GreenButton from "../../components/buttons/GreenButton";
import GreenButtonDowload from "../../components/buttons/GreenButtonDowload";
import EbookCard from "../../components/cards/EbookCard";
import ShareButton from "../../components/buttons/ShareButton";
import {mapState} from "vuex";
// import Loading from 'vue-loading-overlay';
import {BreadcrumbUtil} from "@/util/BreadcrumbUtil";
import book_defalut from "@/assets/book-default.jpg"
import { domain_article, setMetaTags, url_article } from "@/util/Constants";
import axios from "axios";

export default {
  components: {
    EbookImageCard,
    GreenButton,
    GreenButtonDowload,
    // EbookCard,
    ShareButton,
    // Loading
  },
  async created() {
    this.items = BreadcrumbUtil.setServiceItem(
        this.items,
        this.branchId,
        this.branchName,
        this.allBranches,
        this.lang
    )
    this.isLoading = true;
    let id = this.$route.params.slug_id.split('-')[0]
    await this.$store.dispatch('Article/onGetArticleById', {id: id, lang: this.lang});
    setMetaTags(document, window, this.ebook[`subject_${this.lang}`], this.ebook[`intro_${this.lang}`], this.ebook.cover_img_path)
    this.isLoading = false;
  },
  computed: {
    ...mapState({
      branchName: state => state.Branch.branch_name,
      allBranches: state => state.Branch.branches,
      branchId: state => state.Branch.branch_id,
      lang: state => state.Branch.lang,
      ebook: state => state.Article.article
    }),
    branchChanged: function () {
      return this.branchName;
    },
    ebookReady: function () {
      return !!this.ebook && String(this.ebook.article_id) === this.$route.params.slug_id.split('-')[0];
    }
  },
  watch: {
    branchChanged: function () {
      this.items = BreadcrumbUtil.setServiceItem(
          this.items,
          this.branchId,
          this.branchName,
          this.allBranches,
          this.lang
      )
    },
  },
  methods: {
    formatNumber(num) {
      if (num) return num.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ',');
      return num
    },
    set_url(url_pdf) {
      this.path = url_pdf;
    },
    validateEmail(email) {
      if (/([A-Za-z]|[0-9])+@([A-Za-z]|[0-9])+\.([A-Za-z]|[0-9])+/.test(email)) {
        return true;
      } else {
        return false;
      }
    },
    send_info() {
      if (this.name == "") {
        this.$refs.name.focus();
        return false;
      }
      if (this.email == "") {
        this.$refs.email.focus();
        return false;
      } else {
        if (!this.validateEmail(this.email)) {
          return false;
        }
      }
      if (this.occupation == "") {
        this.$refs.occupation.focus();
        return false;
      }
      if (this.industry_id == "") {
        this.$refs.industry_id.focus();
        return false;
      }
      if (!this.accept) {
        return false;
      } else {
        var data = {
          name: this.name,
          email: this.email,
          occupation: this.occupation,
          industry_id: this.industry_id,
          industry_other: this.industry_other,
          pdf_name: this.path,
          article_id: this.ebook.article_id,
          resource: 'TCDC'
        };
        axios.post(url_article + "center/api/save-download-pdf-information", data)
            .then((response) => {
              console.log(response);
              this.downloadEbook(this.path);
              this.dialog = false;
            })
            .catch((error) => {
              console.log(error);
            });
      }
    },
    // downloadEbook(url_path) {
    //   // console.log(path)
    //   // console.log("this.ebook.article_id",this.ebook.id)
    //   if (url_path) {
    //     axios({
    //       url: `https://article.tcdc.or.th/center/api/count-download?article_id=${this.ebook.article_id}`,
    //       method: "GET"
    //     })
    //     window.open(url_article+'/'+url_path);
    //   }
    // },
    downloadEbook(url_path) {
      // console.log(path)
      // console.log("this.ebook.article_id",this.ebook.id)
      if (url_path) {
        axios({
          url: url_article + `center/api/count-download?article_id=${this.ebook.article_id}`,
          method: "GET"
        })
        window.open(url_article + '/' + url_path);
        this.name = "";
        this.email = "";
        this.occupation = "";
        this.industry_id = "";
        this.industry_other = "";
        this.accept = false;
      }
      // this.$store.dispatch("Article/onGetAllEbooks",('1',`${this.lang}`)).then(res=>{
      //   if (res.status ==200){
      //     console.log("this.ebook.count_download",this.ebook.count_download)
      //   }
      // })
      // }
    },
    cancel() {
      this.dialog = false;
      this.name = "";
      this.email = "";
      this.occupation = "";
      this.industry_id = "";
      this.industry_other = "";
      this.accept = false;
      this.$refs.form.resetValidation();
    },
  },
  data: () => ({
    book_defalut: book_defalut,
    isLoading: false,
    items: [
      {
        text: 'TCDC BANGKOK',
        disabled: false,
        to: "/home/:branch"
      },
      {
        text: "SERVICE",
        disabled: false,
        to: "/:branch/service"
      },
      {
        text: "RESOURCE CENTER",
        href: "/:branch/service/resource-center"
      },
      {
        text: "E-BOOK",
        href: "/:branch/service/resource-center/e-book"
      }
    ],
    dialog: false,
    name: "",
    email: "",
    emailRules: [
      v => !!v || 'E-mail is required',
      v => /([A-Za-z]|[0-9])+@([A-Za-z]|[0-9])+\.([A-Za-z]|[0-9])+/.test(v) || 'E-mail must be valid',
    ],
    industryRules: [
      v => !!v || 'Industryis is required',
    ],
    occupation: "",
    path: "",
    industry_id: "",
    industry_other: "",
    accept: false,
    form: "",
    creatives: [
      {
        id: 1,
        name_th: 'การโฆษณา',
        name_en: 'Advertising'
      },
      {
        id: 2,
        name_th: 'การท่องเที่ยวเชิงวัฒนธรรม',
        name_en: 'Cultural and Heritage Tourism'
      },
      {
        id: 3,
        name_th: 'การพิมพ์',
        name_en: 'Publishing'
      },
      {
        id: 4,
        name_th: 'การแพทย์แผนไทย',
        name_en: 'Thai Traditional Medicine'
      },
      {
        id: 5,
        name_th: 'การแพร่ภาพและการกระจายเสียง',
        name_en: 'Broadcasting'
      },
      {
        id: 6,
        name_th: 'การออกแบบ',
        name_en: 'Design'
      },
      {
        id: 7,
        name_th: 'งานฝีมือและหัตถกรรม',
        name_en: 'Crafts'
      },
      {
        id: 8,
        name_th: 'ซอฟต์แวร์',
        name_en: 'Software'
      },
      {
        id: 9,
        name_th: 'ดนตรี',
        name_en: 'Music'
      },
      {
        id: 10,
        name_th: 'ทัศนศิลป์',
        name_en: 'Visual Arts'
      },
      {
        id: 11,
        name_th: 'ภาพยนตร์และวีดิทัศน์',
        name_en: 'Film'
      },
      {
        id: 12,
        name_th: 'ศิลปะการแสดง',
        name_en: 'Performing Arts'
      },
      {
        id: 13,
        name_th: 'สถาปัตยกรรม',
        name_en: 'Architecture'
      },
      {
        id: 14,
        name_th: 'อาหารไทย',
        name_en: 'Thai Food'
      },
      {
        id: 15,
        name_th: 'อุตสาหกรรมแฟชั่น',
        name_en: 'Fashion'
      },
      {
        id: 16,
        name_th: 'อื่น ๆ',
        name_en: 'Other'
      }
    ],
  })
};
</script>

<style scoped>
.font {
  font-family: "Sarabun", sans-serif !important;
}

.font-head {
  font-size: 20px;
  font-family: "kanit", sans-serif !important;
}

.font_10 {
  font-size: 10px;
}

.v-list-item {
  line-height: 2rem !important;
}

.v-select__selection.v-select__selection--comma {
  overflow: inherit !important;
}
</style>
